import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
export default new Router({
  mode: "history",
  base: "/",
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../components/Home"),
      meta: {
        title: "首页",
        requireAuth: true,
        // link: 'default.php?act=memberinfo&url=member'
      },
    },
    {
      path: "/depot/list",
      name: "DepotList",
      // name: 'DepotNew',
      component: () => import("../components/deal/depot/DepotList"),
      // component: () => import("../components/deal/depot/DepotNew"),
      meta: {
        title: "现有仓储单",
        requireAuth: true,
      },
    },
    {
      path: "/depot/history",
      name: "DepotHistory",
      component: () => import("../components/deal/depot/DepotHistory"),
      meta: {
        title: "历史仓储",
        requireAuth: true,
      },
    },
    {
      path: "/depot/log",
      name: "DepotLog",
      component: () => import("../components/deal/depot/DepotLog"),
      meta: {
        title: "仓储日志",
        requireAuth: true,
      },
    },
    {
      path: "/depot/order",
      name: "DepotOrder",
      component: () => import("../components/deal/depot/DepotOrder"),
      meta: {
        title: "仓储转订单",
        requireAuth: true,
      },
    },
    {
      path: "/depot/info/:id",
      name: "DepotInfo",
      component: () => import("../components/deal/depot/DepotInfo"),
      meta: {
        title: "仓储单详情",
        requireAuth: true,
      },
    },
    {
      path: "/depot/over",
      name: "DepotOver",
      component: () => import("../components/deal/depot/DepotOver"),
      meta: {
        title: "超期仓储单",
        requireAuth: true,
      },
    },
    {
      path: "/tag/list",
      name: "TagList",
      component: () => import("../components/deal/tag/TagList"),
      meta: {
        title: "自定义吊牌",
        requireAuth: true,
      },
    },
    {
      path: "/tag/add",
      name: "TagAdd",
      component: () => import("../components/deal/tag/TagAdd"),
      meta: {
        title: "自定义吊牌",
        requireAuth: true,
      },
    },
    {
      path: "/order/import",
      name: "OrderImport",
      component: () => import("../components/deal/orders/OrderImport"),
      meta: {
        title: "订单批量导入",
        requireAuth: true,
      },
    },
    {
      path: "/finance/balance",
      name: "FinanceBalance",
      component: () => import("../components/user/finance/FinanceBalance"),
      meta: {
        title: "账户余额",
        requireAuth: true,
        // link: 'default.php?url=member&act=finance&type=4'
      },
    },
    {
      path: "/deposit/apply",
      name: "DepositApply",
      component: () => import("../components/user/finance/DepositApply"),
      meta: {
        title: "申请提现",
        requireAuth: true,
      },
    },
    {
      path: "/recharge",
      name: "Recharge",
      component: () => import("../components/user/finance/Recharge"),
      meta: {
        title: "余额充值",
        requireAuth: true,
      },
    },
    // {
    //     path: '/recharge/gold',
    //     name: 'GoldRecharge',
    //     component: () => import("../components/user/finance/GoldRecharge"),
    //     meta: {
    //         title: '金币充值',
    //         requireAuth: true
    //     }
    // },
    {
      path: "/point/list",
      name: "PointList",
      component: () => import("../components/user/finance/PointList"),
      meta: {
        title: "积分明细",
        requireAuth: true,
      },
    },
    {
      path: "/point/rule",
      name: "PointRule",
      component: () => import("../components/user/finance/PointRule"),
      meta: {
        title: "积分规则",
        requireAuth: true,
      },
    },
    {
      path: "/finance/list",
      name: "FinanceList",
      component: () => import("../components/user/finance/FinanceList"),
      meta: {
        title: "交易明细",
        requireAuth: true,
        // link: 'default.php?act=accounts&url=member'
      },
    },
    {
      path: "/voucher",
      name: "Voucher",
      component: () => import("../components/user/account/Voucher"),
      meta: {
        title: "优惠劵",
        requireAuth: true,
        // link: 'default.php?act=voucherList&url=member'
      },
    },
    {
      path: "/info",
      name: "UserInfo",
      component: () => import("../components/user/account/UserInfo"),
      meta: {
        title: "个人信息",
        requireAuth: true,
        // link: 'default.php?act=personal&url=member'
      },
    },
    {
      path: "/cert/account",
      name: "CertAccount",
      component: () => import("../components/user/cert/CertAccount"),
      meta: {
        title: "用户认证",
        requireAuth: true,
        // link: 'default.php?act=Tcertify&url=member'
      },
    },
    {
      path: "/safe",
      name: "AccountSafe",
      component: () => import("../components/user/account/AccountSafe"),
      meta: {
        title: "账户与安全",
        requireAuth: true,
        // link: 'default.php?act=safe&url=member'
      },
    },
    {
      path: "/bind/mobile",
      name: "BindMobile",
      component: () => import("../components/user/account/BindMobile"),
      meta: {
        title: "修改绑定手机号",
        requireAuth: true,
        // link: 'default.php?url=member&act=update_mobile'
      },
    },
    {
      path: "/bind/email",
      name: "BindEmail",
      component: () => import("../components/user/account/BindEmail"),
      meta: {
        title: "绑定邮箱",
        requireAuth: true,
        // link: 'default.php?act=update_email&url=member'
      },
    },
    {
      path: "/password",
      name: "Password",
      component: () => import("../components/user/account/Password"),
      meta: {
        title: "修改登录密码",
        requireAuth: true,
        // link: 'default.php?act=Password&url=member'
      },
    },
    {
      path: "/paypsd",
      name: "PayPassword",
      component: () => import("../components/user/account/PayPassword"),
      meta: {
        title: "修改支付密码",
        requireAuth: true,
        // link: 'default.php?act=paypsd&url=member'
      },
    },
    {
      path: "/jd/paypsd",
      name: "PayJdPassword",
      component: () => import("../components/user/account/PayJdPassword"),
      meta: {
        title: "设置支付密码",
        requireAuth: false,
      },
    },
    {
      path: "/question",
      name: "Question",
      component: () => import("../components/user/account/Question"),
      meta: {
        title: "密保问题",
        requireAuth: true,
        // link: 'default.php?act=security_question&url=member'
      },
    },
    {
      path: "/cancel",
      name: "Cancel",
      component: () => import("../components/user/account/Cancel"),
      meta: {
        title: "账号注销",
        requireAuth: true,
        // link: 'default.php?act=writeoff&url=member'
      },
    },
    {
      path: "/cancel/fail",
      name: "CancelFail",
      component: () => import("../components/user/account/CancelFail"),
      meta: {
        title: "账号注销失败",
        requireAuth: true,
      },
    },
    {
      path: "/address",
      name: "Address",
      component: () => import("../components/user/account/Address"),
      meta: {
        title: "地址管理",
        requireAuth: true,
      },
    },
    {
      path: "/collect/goods",
      name: "CollectGoods",
      component: () => import("../components/focus/CollectGoods"),
      meta: {
        title: "收藏的商品",
        requireAuth: true,
      },
    },
    {
      path: "/focus/store",
      name: "FocusStore",
      component: () => import("../components/focus/FocusStore"),
      meta: {
        title: "关注的商家",
        requireAuth: true,
        // link: 'default.php?act=snsList&url=member'
      },
    },
    {
      path: "/trace",
      name: "Trace",
      component: () => import("../components/focus/Trace"),
      meta: {
        title: "我的足迹",
        requireAuth: true,
        // link: 'default.php?act=trace&url=member'
      },
    },
    {
      path: "/distribution/order",
      name: "DistributionOrder",
      component: () => import("../components/distribution/DistributionOrder"),
      meta: {
        title: "分销订单",
        requireAuth: true,
      },
    },
    {
      path: "/distribution/order/detail",
      name: "DistributionOrderDetail",
      component: () =>
        import("../components/distribution/DistributionOrderDetail"),
      meta: {
        title: "分销订单详情",
        requireAuth: true,
      },
    },
    {
      path: "/distribution/list",
      name: "DistributionList",
      component: () => import("../components/distribution/DistributionList"),
      meta: {
        title: "分销资产",
        requireAuth: true,
      },
    },
    {
      path: "/distribution/deposit",
      name: "DistributionDeposit",
      component: () => import("../components/distribution/DistributionDeposit"),
      meta: {
        title: "分销账户提现申请",
        requireAuth: true,
      },
    },
    {
      path: "/distribution/transpond",
      name: "DistributeTranspond",
      component: () => import("../components/distribution/DistributeTranspond"),
      meta: {
        title: "我的转发",
        requireAuth: true,
      },
    },
    {
      path: "/distribution/recycle",
      name: "DistributeRecycle",
      component: () => import("../components/distribution/DistributeRecycle"),
      meta: {
        title: "回收站",
        requireAuth: true,
      },
    },
    {
      path: "/refund/list",
      name: "RefundList",
      component: () => import("../components/deal/refund/RefundListNew"),
      meta: {
        title: "退款列表",
        requireAuth: true,
        // link: 'default.php?url=member&act=refund'
      },
    },
    {
      path: "/refund/detail/:id",
      name: "RefundDetail",
      component: () => import("../components/deal/refund/RefundDetailNew"),
      meta: {
        title: "退货退款详情",
        requireAuth: true,
      },
    },
    {
      path: "/complain/list",
      name: "ComplainList",
      component: () => import("../components/deal/complain/ComplainList"),
      meta: {
        title: "投诉管理",
        requireAuth: true,
        // link: 'default.php?act=complain&url=member'
      },
    },
    {
      path: "/complain/detail/:id",
      name: "ComplainDetail",
      component: () => import("../components/deal/complain/ComplainDetail"),
      meta: {
        title: "投诉详情",
        requireAuth: true,
      },
    },
    {
      path: "/complain/apply/:id",
      name: "ComplainApply",
      component: () => import("../components/deal/complain/ComplainApply"),
      meta: {
        title: "订单投诉",
        requireAuth: true,
      },
    },
    {
      path: "/violation/list",
      name: "Violation",
      component: () => import("../components/deal/violation/Violation"),
      meta: {
        title: "举报信息",
        requireAuth: true,
      },
    },
    {
      path: "/express/bill",
      name: "ExpressBill",
      component: () => import("../components/functions/express/ExpressBill"),
      meta: {
        title: "快递面单",
        requireAuth: true,
      },
    },
    {
      path: "/notice",
      name: "Notice",
      component: () => import("../components/notice/Notice"),
      meta: {
        title: "消息通知",
        requireAuth: true,
        // link: 'default.php?url=member&act=weixinNotice'
      },
    },
    {
      path: "/publish/list",
      name: "PublishList",
      component: () => import("../components/functions/publish/PublishList"),
      meta: {
        title: "我的信息",
        requireAuth: true,
        link: "default.php?act=pbinfo&url=member",
      },
    },
    {
      path: "/publish/published",
      name: "PublishedList",
      component: () => import("../components/functions/publish/PublishedTable"),
      meta: {
        title: "已发布上网",
        requireAuth: true,
      },
    },
    {
      path: "/publish/top",
      name: "PublishTop",
      component: () => import("../components/functions/publish/PublishTop"),
      meta: {
        title: "信息置顶",
        requireAuth: true,
      },
    },
    {
      path: "/correct",
      name: "Correct",
      component: () => import("../components/functions/Correct"),
      meta: {
        title: "我的纠错",
        requireAuth: true,
        //link: 'default.php?act=jiucuo&url=member'
      },
    },
    {
      path: "/update",
      name: "Update",
      component: () => import("../components/functions/Update"),
      meta: {
        title: "我的上传",
        requireAuth: true,
      },
    },
    {
      path: "/data",
      name: "DataPackage",
      component: () =>
        import("../components/functions/datapackage/DataPackage"),
      meta: {
        title: "数据包",
        requireAuth: true,
        // link: 'default.php?act=csv&url=member'
      },
    },
    {
      path: "/data/table",
      name: "DataPackageTable",
      component: () =>
        import("../components/functions/datapackage/DataPackageTable"),
      meta: {
        title: "数据包管理",
        requireAuth: true,
      },
    },
    {
      path: "/data/downlist",
      name: "DownloadTable",
      component: () =>
        import("../components/functions/datapackage/DownloadTable"),
      meta: {
        title: "查看下载数据",
        requireAuth: true,
      },
    },
    {
      path: "/express/send",
      name: "SendExpress",
      component: () => import("../components/functions/express/SendExpress"),
      meta: {
        title: "寄快递",
        requireAuth: true,
        // link: 'default.php?act=shipping&url=member'
      },
    },
    {
      path: "/express/manage",
      name: "ExpressManage",
      component: () => import("../components/functions/express/ExpressManage"),
      meta: {
        title: "快递管理",
        requireAuth: true,
      },
    },
    {
      path: "/express/logistics",
      name: "ExpressLogistics",
      component: () =>
        import("../components/functions/express/ExpressLogistics"),
      meta: {
        title: "查看物流",
        requireAuth: true,
      },
    },
    {
      path: "/express/freight",
      name: "ExpressFreight",
      component: () => import("../components/functions/express/ExpressFreight"),
      meta: {
        title: "运费计算",
        requireAuth: true,
      },
    },
    {
      path: "/express/account",
      name: "ExpressAccount",
      component: () => import("../components/functions/express/ExpressAccount"),
      meta: {
        title: "快递账户管理",
        requireAuth: true,
      },
    },
    {
      path: "/express/import",
      name: "ExpressImport",
      component: () => import("../components/functions/express/ExpressImport"),
      meta: {
        title: "快递批量导入",
        requireAuth: true,
      },
    },
    {
      path: "/eva/list",
      name: "EvaList",
      component: () => import("../components/deal/evaluate/EvaList"),
      meta: {
        title: "评价商品列表",
        requireAuth: true,
        //link: 'default.php?url=member&act=evaluate'
      },
    },
    {
      path: "/eva/detail",
      name: "EvaDetail",
      component: () => import("../components/deal/evaluate/EvaDetail"),
      meta: {
        title: "评价详情",
        requireAuth: true,
      },
    },
    {
      path: "/order/list",
      name: "OrderList",
      component: () => import("../components/deal/orders/OrderList"),
      meta: {
        title: "我的订单",
        requireAuth: true,
        // link: 'default.php?url=member&act=order'
      },
    },
    {
      path: "/order/detail/:id",
      name: "OrderDetail",
      component: () => import("../components/deal/orders/OrderDetail"),
      meta: {
        title: "订单详情",
        requireAuth: true,
      },
    },
    {
      path: "/ordering",
      name: "Ordering",
      component: () => import("../components/deal/orders/Ordering"),
      meta: {
        title: "订单结算",
        requireAuth: true,
      },
    },
    {
      path: "/order/receive",
      name: "OrderReceive",
      component: () => import("../components/deal/orders/OrderReceive"),
      meta: {
        title: "确认收货",
        requireAuth: true,
      },
    },
    {
      path: "/order/diffprice",
      name: "OrderDiffPrice",
      component: () => import("../components/deal/orders/OrderDiffPrice"),
      meta: {
        title: "补差价",
        requireAuth: true,
      },
    },
    {
      path: "/order/recycle",
      name: "OrderRecycle",
      component: () => import("../components/deal/orders/OrderRecycle"),
      meta: {
        title: "订单回收站",
        requireAuth: true,
      },
    },
    {
      path: "/order/evaluate/:id",
      name: "OrderEvaluate",
      component: () => import("../components/deal/orders/OrderEvaluate"),
      meta: {
        title: "评价订单",
        requireAuth: true,
      },
    },
    // {
    //     path: '/refund/apply',
    //     name: 'RefundApply',
    //     component: () => import("../components/deal/refund/RefundApplyRefactor"),
    //     meta: {
    //         title: '申请退款退货',
    //         requireAuth: true
    //     }
    // },
    {
      path: "/refund/apply",
      name: "RefundApply",
      component: () => import("../components/deal/refund/RefundApplySelect"),
      meta: {
        title: "申请退款退货列表",
        requireAuth: true,
      },
    },
    {
      path: "/refund/applySubmit",
      name: "RefundApplySubmit",
      component: () => import("../components/deal/refund/RefundApplyRefactor"),
      meta: {
        title: "申请退款退货",
        requireAuth: true,
      },
    },
    {
      path: "/depoting",
      name: "Depoting",
      component: () => import("../components/deal/depot/Depoting"),
      meta: {
        title: "囤货结算",
        requireAuth: true,
      },
    },
    {
      path: "/taobao/order",
      name: "TaobaoOrder",
      component: () => import("../components/deal/third/TaobaoOrder"),
      meta: {
        title: "淘宝订单",
        requireAuth: true,
        // link: 'default.php?url=member&act=tborder'
      },
    },
    {
      path: "/dy/order",
      name: "DyOrder",
      component: () => import("../components/deal/third/DyOrder"),
      meta: {
        title: "抖店订单",
        requireAuth: true,
      },
    },
    {
      path: "/pdd/order",
      name: "PddOrder",
      component: () => import("../components/deal/third/PddOrder"),
      meta: {
        title: "拼多多订单",
        requireAuth: true,
      },
    },
    // {
    //     path: '/jd/order',
    //     name: 'JdOrder',
    //     component: () => import("../components/deal/third/JdOrder"),
    //     meta: {
    //         title: '京东订单',
    //         requireAuth: true,
    //         link: 'default.php?url=member&act=jd'
    //     }
    // },
    {
      path: "/refund/help/list",
      name: "HelpRefundList",
      component: () => import("../components/deal/refund/HelpRefundList"),
      meta: {
        title: "帮忙退货",
        requireAuth: true,
      },
    },
    {
      path: "/refund/help/add",
      name: "AddHelpRefund",
      component: () => import("../components/deal/refund/AddHelpRefund"),
      meta: {
        title: "申请帮忙退货",
        requireAuth: true,
      },
    },
    {
      path: "/refund/help/detail",
      name: "HelpRefundDetail",
      component: () => import("../components/deal/refund/HelpRefundDetail"),
      meta: {
        title: "帮忙退货详情",
        requireAuth: true,
      },
    },
    {
      path: "/refund/help/shipping",
      name: "HelpRefundShipping",
      component: () => import("../components/deal/refund/HelpRefundShipping"),
      meta: {
        title: "帮忙退货",
        requireAuth: true,
      },
    },
    {
      path: "/account",
      name: "Account",
      component: () => import("../components/user/account/Account"),
      meta: {
        title: "账户管理",
        requireAuth: true,
        link: "default.php?act=Tcertify&url=member",
      },
    },
    {
      path: "/cart",
      name: "Cart",
      component: () => import("../components/deal/Cart"),
      meta: {
        title: "采购车",
        requireAuth: true,
      },
    },
    {
      path: "/cert/user",
      name: "UserCertType",
      component: () => import("../components/user/cert/UserCertType"),
      meta: {
        title: "用户认证",
        requireAuth: true,
      },
    },
    {
      path: "/cert/info",
      name: "UserCertInfo",
      component: () => import("../components/user/cert/UserCertInfo"),
      meta: {
        title: "用户认证",
        requireAuth: true,
      },
    },
    {
      path: "/notice/:id",
      name: "NoticeInfo",
      component: () => import("../components/notice/NoticeInfo"),
      meta: {
        title: "公告详情",
        requireAuth: true,
      },
    },
    {
      path: "/login",
      name: "Login",
      component: () => import("../components/Login"),
      meta: {
        title: "用户登录",
        // link: 'default.php?url=member&act=memberinfo'
      },
    },
    {
      path: "/forget",
      name: "Forget",
      component: () => import("../components/Forget"),
      meta: {
        title: "忘记密码",
      },
    },
    {
      path: "/reg/store",
      name: "RegStore",
      component: () => import("../components/register/RegStore"),
      meta: {
        title: "商家注册",
      },
    },
    {
      path: "/reg/person",
      name: "RegPerson",
      component: () => import("../components/register/RegPerson"),
      meta: {
        title: "用户注册",
      },
    },
    {
      path: "/reg/success",
      name: "RegSuccess",
      component: () => import("../components/register/RegSuccess"),
      meta: {
        title: "注册成功",
      },
    },
    {
      path: "/tools/manage",
      name: "WebManage",
      component: () => import("../components/tools/WebManage"),
      meta: {
        title: "网店管理",
        requireAuth: true,
      },
    },
    {
      path: "/tools/match",
      name: "WebMatch",
      component: () => import("../components/tools/WebMatch"),
      meta: {
        title: "高级匹配",
        requireAuth: true,
      },
    },
    {
      path: "/tools/detail",
      name: "WebMatchDetail",
      component: () => import("../components/tools/WebMatchDetail"),
      meta: {
        title: "匹配详情",
      },
    },
    {
      path: "/kefu",
      name: "KefuTools",
      component: () => import("../components/common/KefuTools"),
      meta: {
        title: "在线客服",
      },
    },
    {
      path: "/404",
      name: "NotFound",
      component: () => import("../components/NotFound"),
      meta: {
        title: "页面不存在",
      },
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/refund/type/select",
      name: "RefundSelect",
      component: () => import("../components/deal/refund/RefundTypeSelect"),
      meta: {
        title: "退款类型选择页面",
        requireAuth: true,
      },
    },
    {
      path: "/byp/list",
      name: "BypList",
      component: () => import("../components/byp/BypList"),
      meta: {
        title: "包邮拼",
        requireAuth: true,
      },
    },
    {
      path: "/byp/deposit",
      name: "BypDeposit",
      component: () => import("../components/byp/BypDeposit"),
      meta: {
        title: "包邮拼定金支付",
        requireAuth: true,
      },
    },
    {
      path: "/byp/order",
      name: "BypOrder",
      component: () => import("../components/byp/BypOrder"),
      meta: {
        title: "包邮拼尾款支付",
        requireAuth: true,
      },
    },
    {
      path: "/byp/info/:id",
      name: "BypInfo",
      component: () => import("../components/byp/BypInfo"),
      meta: {
        title: "包邮拼订单详情",
        requireAuth: true,
      },
    },
    {
      path: "/mz/ordering",
      name: "MzOrdering",
      component: () => import("../components/mz/MzOrdering"),
      meta: {
        title: "订单结算",
        requireAuth: true,
      },
    },
    {
      path: "/mz/auth",
      name: "MzAuth",
      component: () => import("../components/MzAuth"),
      meta: {
        title: "美折授权",
        // requireAuth: true
      },
    },
    {
      path: "/puhuo",
      name: "PuhuoList",
      component: () => import("../components/functions/puhuo/PuhuoList"),
      meta: {
        title: "铺货管理1",
        requireAuth: true,
      },
    },
    {
      path: "/puhuoV2",
      name: "PuhuoList_v2",
      component: () => import("../components/functions/puhuo/PuhuoList_v2"),
      meta: {
        title: "铺货管理",
        requireAuth: true,
      },
    },
    {
      path: "/puhuo/store",
      name: "PuhuoStore",
      component: () => import("../components/functions/puhuo/Store"),
      meta: {
        title: "铺货店铺",
        requireAuth: true,
      },
    },
    // {
    //   path: "/intercept",
    //   name: "Intercept",
    //   component: () => import("../components/user/Intercept"),
    //   meta: {
    //     title: "运费拦截",
    //     requireAuth: true,
    //   },
    // },
    {
      path: "/pay/page",
      name: "PayPage",
      component: () => import("../components/common/PayPage"),
      meta: {
        title: "收银台",
        requireAuth: false,
      },
    },
    ,
    {
      path: "/pay/close",
      name: "PayClose",
      component: () => import("../components/common/PayClose"),
      meta: {
        title: "支付关闭页",
        requireAuth: false,
      },
    },
    {
      path: "/jst/goods/upload",
      name: "JstGoodsUpload",
      component: () => import("../components/functions/puhuo/JstGoodsUpload"),
      meta: {
        title: "铺货到聚水潭",
        requireAuth: false,
      },
    }
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js